if (!customElements.get('birthday-capture-form')) {
  class BirthdayForm extends HTMLElement {

    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.successMessage = this.getAttribute('success-message');
      this.successMessageEl = this.querySelector('[data-success]');
      this.source = this.getAttribute('form-source');
      this.formMain = this.querySelector('[data-form-main]');
    }

    onSubmit(event) {
      event.preventDefault();
      const email = event.target.elements.email.value;
      const birthdayValue = event.target.elements.birthday.valueAsDate;
      const birthday = new Date(birthdayValue);
      const birthdayFormatted = birthdayValue ? `${birthday.getMonth() + 1}/${birthday.getDate()}/${birthday.getFullYear()}` : null;
      const klaviyoListId = event.target.dataset.klaviyoList;
      klaviyoSubscribe(klaviyoListId, email, 'Birthday Signup Page', null, null, birthdayFormatted);
      this.formMain.style.display = 'none';
      this.successMessageEl.classList.remove('hidden');
      this.form.reset();
    }
  }
  customElements.define('birthday-capture-form', BirthdayForm);
}